module.exports = __webpack_public_path__ + "static/media/Patient.681bf87c.svg";